import { useEffect, useState } from "react";
import Summary from "../Summary";
import { LinearProgress } from "~/components/UI";
import api from "~/api";
import { SOURCE_TYPE } from '~/api/common';

const PaymentServicesSummary = () => {
  const [loading, setLoading] = useState(true);
  const [summaryData, setSummaryData] =
    useState<DashboardCatalogsAPI.DashboardCatalogDto>();

  const getData = async () => {
    try {
      setLoading(true);
      const { data } = await api.dashboardCatalogs.getPaymentServicesSummary();
      setSummaryData(data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <LinearProgress hidden={!loading} />
      {summaryData && (
        <Summary
          sourceType={SOURCE_TYPE.PAYMENT_SERVICE}
          active={summaryData.active}
          disabled={summaryData.disabled}
          totalQuantity={summaryData.totalQuantity}
          openedIncidents={summaryData.incidents.count}
        />
      )}
    </>
  );
};

export default PaymentServicesSummary;
